module.exports = {
      id: "send-usage",
      viewBox: "0 0 1054 1013",
      url: __webpack_public_path__ + "img/icons.0526cd7f.svg#send-usage",
      toString: function () {
        return this.url;
      }
    }